import $ from 'jquery';

export default () => {
    const slider = $('.js-tab-slider');

    if (slider.is('*')) {
        const tabs = $('.js-tab-slider-tabs');
        const slides = $('.js-tab-slider-slides');

        tabs.slick({
            arrows: false,
            asNavFor: '.js-tab-slider-slides',
            slidesToShow: 3,
            focusOnSelect: true,
            infinite: false
        });

        slides.slick({
            arrows: false,
            asNavFor: '.js-tab-slider-tabs',
            infinite: false
        });
    }
}
